import { useEffect, useState } from "react";

const letters = ["V", "I", "B", "R", "A", "N", "T", "V", "I", "V", "A"];

const Preloader = ({ loading }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) { clearInterval(interval); return 100; }
        return prev + 1;
      });
    }, 22);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: `
        @import url('https://fonts.googleapis.com/css2?family=Kumbh+Sans:wght@100;300;400&display=swap');

        .pre-root {
          position: fixed;
          inset: 0;
          z-index: 9999999;
          pointer-events: all;
          font-family: 'Kumbh Sans', sans-serif;
        }
        .pre-root.done {
          pointer-events: none;
          visibility: hidden;
          -webkit-transition-delay: 1.5s;
          -o-transition-delay: 1.5s;
          transition-delay: 1.5s;
        }
        .pre-root.done .pre-panel-top {
          transform: translateY(-100%);
        }
        .pre-root.done .pre-panel-bottom {
          transform: translateY(100%);
        }
        .pre-root.done .pre-content {
          opacity: 0;
          transform: translate(-50%, -50%) scale(0.95);
        }
        .pre-root.done .pre-seam {
          opacity: 0;
        }

        /* ── top panel ── */
        .pre-panel-top {
          position: fixed;
          top: 0; left: 0;
          width: 100%;
          height: 50vh;
          background: #000000;
          transform: translateY(0);
          transition: transform 1s cubic-bezier(0.77, 0, 0.175, 1) 0.3s;
          z-index: 9999998;
        }

        /* ── bottom panel ── */
        .pre-panel-bottom {
          position: fixed;
          bottom: 0; left: 0;
          width: 100%;
          height: 50vh;
          background: #000000;
          transform: translateY(0);
          transition: transform 1s cubic-bezier(0.77, 0, 0.175, 1) 0.3s;
          z-index: 9999998;
        }

        /* ── horizontal seam line at center ── */
        .pre-seam {
          position: fixed;
          top: 50%;
          left: 0;
          width: 100%;
          height: 1px;
          background: rgba(255,255,255,0.06);
          z-index: 9999999;
          transform: translateY(-50%);
          transition: opacity 0.2s ease 0.2s;
        }

        /* ── centered content ── */
        .pre-content {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 99999999;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 18px;
          pointer-events: none;
          transition: opacity 0.2s ease, transform 0.2s ease;
        }

        /* ── letters ── */
        .pre-letters {
          display: flex;
          align-items: center;
        }
        .pre-letter {
          font-size: 15px;
          font-weight: 300;
          letter-spacing: 10px;
          text-transform: uppercase;
          color: rgba(255,255,255,0.82);
          display: inline-block;
          opacity: 0;
          transform: translateY(10px);
          animation: letterIn 0.6s cubic-bezier(0.22,1,0.36,1) forwards;
        }
        .pre-letter:nth-child(1)  { animation-delay: 0.05s; }
        .pre-letter:nth-child(2)  { animation-delay: 0.10s; }
        .pre-letter:nth-child(3)  { animation-delay: 0.15s; }
        .pre-letter:nth-child(4)  { animation-delay: 0.20s; }
        .pre-letter:nth-child(5)  { animation-delay: 0.25s; }
        .pre-letter:nth-child(6)  { animation-delay: 0.30s; }
        .pre-letter:nth-child(7)  { animation-delay: 0.35s; }
        .pre-letter:nth-child(8)  { animation-delay: 0.40s; }
        .pre-letter:nth-child(9)  { animation-delay: 0.45s; }
        .pre-letter:nth-child(10) { animation-delay: 0.50s; }
        .pre-letter:nth-child(11) { animation-delay: 0.55s; }
        .pre-letter:nth-child(12) { animation-delay: 0.60s; }
        .pre-letter.space { width: 18px; }

        @keyframes letterIn {
          to { opacity: 1; transform: translateY(0); }
        }

        /* ── progress bar ── */
        .pre-bar-wrap {
          width: 180px;
          opacity: 0;
          animation: fadeIn 0.5s ease 0.7s forwards;
        }
        .pre-bar-track {
          width: 100%;
          height: 1px;
          background: rgba(255,255,255,0.12);
          border-radius: 99px;
        }
        .pre-bar-fill {
          height: 1px;
          border-radius: 99px;
          background: rgba(255,255,255,0.75);
          transition: width 0.08s linear;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
      `}} />

      <div className={`pre-root${!loading ? " done" : ""}`}>

        {/* two panels that split top/bottom */}
        <div className="pre-panel-top" />
        <div className="pre-panel-bottom" />
        <div className="pre-seam" />

        {/* text + bar floats above both panels */}
        <div className="pre-content">
          <div className="pre-letters">
            {letters.map((l, i) =>
              l === " " ? (
                <span key={i} className="pre-letter space" />
              ) : (
                <span key={i} className="pre-letter">{l}</span>
              )
            )}
          </div>
          <div className="pre-bar-wrap">
            <div className="pre-bar-track">
              <div className="pre-bar-fill" style={{ width: `${progress}%` }} />
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default Preloader;